<div class="landing-page">
    <app-header></app-header>
    @if(impersonatedUser!==''){<app-impersonation-header></app-impersonation-header>}
    <main>
        <app-main></app-main>
    </main>
    <app-footer-layout></app-footer-layout>
</div>